<script setup lang="ts"></script>
<template>
  <router-view />
  <svg id="line-gradient-parent" style="position: absolute; height: 0">
    <defs>
      <linearGradient id="line-gradient">
        <stop offset="0%" stop-color="#F5F5F5" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          ></animate>
        </stop>
        <stop offset="50%" stop-color="#F9F9F9" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          ></animate>
        </stop>
        <stop offset="100%" stop-color="#F5F5F5" stop-opacity="1">
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          ></animate>
        </stop>
      </linearGradient>
    </defs>
  </svg>
</template>
<style>
body {
  margin: 0;
}

.loading-gradient {
  background: repeating-linear-gradient(to right, #f5f5f5 20%, #f9f9f9 50%, #f5f5f5 80%);
  background-repeat: repeat-x;
  animation: moving-gradient 2s linear infinite;
  background-size: 400% 100%;
}

@keyframes moving-gradient {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -33% 0;
  }
}
</style>
